<template>
  <span
    :class="sbBadgeVariationClasses"
    data-sb-regression="sb-badge"
  >
    <!--
      @slot text, components, or HtmlElements as children of the component
     -->
    <slot />
  </span>
</template>
<script>

/**
 * Displays a small message inside a formatted element.
 * Typically used with a numerical indicator associated with a link.
 */
export default {
  name: 'SbBadge',
  props: {
    /**
     * Style variation to give additional meaning.
     * `primary, error, warning, success, disabled, monochrome`
    */
    variation: {
      type: String,
      default: 'primary',
      validator: (value) => {
        return value.match(/(primary|error|warning|success|disabled|monochrome)/);
      },
    },
    /**
     * The size of the badge. Defaults to small.
     * `extra-small, small, medium, large`
     */
    size: {
      type: String,
      default: 'small',
      validator: (value) => {
        return value.match(/(extra-small|small|medium|large)/);
      },
    },
  },
  computed: {
    sbBadgeVariationClasses() {
      return ['sb-badge', `sb-badge--${this.variation}`, `sb-badge--${this.size}`];
    },
  },
};
</script>
<style scoped lang='scss'>
@import '@src/components/Badge/style/sb-badge.scss';
</style>
